// extracted by mini-css-extract-plugin
export default {"modal":"SelectRuleGroupModal_modal__-7Jyp","tips":"SelectRuleGroupModal_tips__bZ2SX","tip":"SelectRuleGroupModal_tip__cpPm1"};